"use client";

import { c as _c } from "react/compiler-runtime";
import { useQuery } from "@tanstack/react-query";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import BgPointsMobile from "@/assets/images/account/bg-points-mobile.png";
import BgPointsPC from "@/assets/images/account/bg-points-pc.png";
import { PopLoading } from "@/components/pop-ui/pop-loading";
import { Button } from "@/components/ui/button";
import { PullToRefreshWrapper } from "@/components/ui/pull-to-refresh";
import { useIsMobile } from "@/hooks/use-mobile";
import LocaleLink from "@/lib/i18n/locale-link";
import { cn, formatDate, getCurrencySymbol } from "@/lib/utils";
import { getDefaultCurrencyByRegion } from "@/lib/utils.client";
import { ModulePagination } from "@/modules/users/account/components/module-pagination";
import { useORPC } from "@/providers/orpc-provider";
import { ModuleSectionTitle, ModuleTitle } from "./components/module-title";
export function PointsModule() {
  const $ = _c(38);
  const {
    t
  } = useTranslation();
  const orpcClient = useORPC();
  const isMobile = useIsMobile();
  const [currentPage, setCurrentPage] = useState(1);
  let t0;
  if ($[0] !== orpcClient.member.getCurrentPoints) {
    t0 = orpcClient.member.getCurrentPoints.queryOptions({
      input: {}
    });
    $[0] = orpcClient.member.getCurrentPoints;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== t0) {
    t1 = {
      ...t0
    };
    $[2] = t0;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const {
    data: currentPointsData,
    isLoading: isLoadingCurrentPoints,
    refetch: refetchCurrentPoints
  } = useQuery(t1);
  let t2;
  if ($[4] !== currentPage || $[5] !== orpcClient.member.getMemberPointHistory) {
    t2 = orpcClient.member.getMemberPointHistory.queryOptions({
      input: {
        page: currentPage,
        pageSize: 10
      }
    });
    $[4] = currentPage;
    $[5] = orpcClient.member.getMemberPointHistory;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  let t3;
  if ($[7] !== t2) {
    t3 = {
      ...t2
    };
    $[7] = t2;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  const {
    data: pointsHistoryData,
    isLoading: isLoadingPointsHistory,
    refetch: refetchPointsHistory
  } = useQuery(t3);
  let t4;
  if ($[9] !== refetchCurrentPoints || $[10] !== refetchPointsHistory) {
    t4 = async () => {
      await Promise.all([refetchCurrentPoints(), refetchPointsHistory()]);
    };
    $[9] = refetchCurrentPoints;
    $[10] = refetchPointsHistory;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  const handleRefresh = t4;
  let t5;
  let t6;
  if ($[12] !== t) {
    const defaultCurrency = getDefaultCurrencyByRegion();
    const currencySymbol = getCurrencySymbol(defaultCurrency);
    t5 = t("account.points.cards.order.title", "\u4E0B\u55AE");
    t6 = t("account.points.cards.order.desc", "\u6BCF\u6D88\u8CBB{currency}1.00\u7372\u5F971\u7A4D\u5206", {
      currency: currencySymbol
    });
    $[12] = t;
    $[13] = t5;
    $[14] = t6;
  } else {
    t5 = $[13];
    t6 = $[14];
  }
  let t7;
  if ($[15] !== t) {
    t7 = t("account.points.cards.order.button", "\u53BB\u8CFC\u7269");
    $[15] = t;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  let t8;
  if ($[17] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = {
      disabled: false,
      className: "mt-4 w-full md:w-auto self-start"
    };
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  let t9;
  if ($[18] !== t5 || $[19] !== t6 || $[20] !== t7) {
    t9 = [{
      title: t5,
      desc: t6,
      buttonText: t7,
      buttonProps: t8,
      link: "/"
    }];
    $[18] = t5;
    $[19] = t6;
    $[20] = t7;
    $[21] = t9;
  } else {
    t9 = $[21];
  }
  const getPointsCards = t9;
  const totalPages = pointsHistoryData?.totalPages ?? 1;
  let t10;
  if ($[22] !== totalPages) {
    t10 = newPage => {
      if (newPage >= 1 && newPage <= totalPages) {
        setCurrentPage(newPage);
      }
    };
    $[22] = totalPages;
    $[23] = t10;
  } else {
    t10 = $[23];
  }
  const handlePageChange = t10;
  let t11;
  if ($[24] !== currentPage || $[25] !== currentPointsData?.points || $[26] !== getPointsCards || $[27] !== handlePageChange || $[28] !== isLoadingCurrentPoints || $[29] !== isLoadingPointsHistory || $[30] !== pointsHistoryData || $[31] !== t || $[32] !== totalPages) {
    t11 = () => {
      if (isLoadingCurrentPoints || isLoadingPointsHistory) {
        return <div className={cn("flex justify-center items-center py-10", "min-h-75")}><PopLoading /></div>;
      }
      return <div><div><div className={cn("flex justify-between items-center", "md:mb-2")}><ModuleTitle title={t("user_account.my_points_title", "\u6211\u7684\u7A4D\u5206")} /></div><div className={cn("w-full bg-[#f5f5f5] text-black relative overflow-hidden", "h-46 md:h-[13.69rem]", "mb-0 md:mb-12")}><div className={cn("absolute inset-0 bg-no-repeat bg-cover", "md:block hidden")} style={{
              backgroundImage: `url(${BgPointsPC.src})`
            }} aria-hidden="true" /><div className={cn("absolute inset-0 bg-no-repeat bg-cover", "md:hidden")} style={{
              backgroundImage: `url(${BgPointsMobile.src})`
            }} aria-hidden="true" /><div className="absolute inset-0"><div className="flex justify-end items-center"><LocaleLink href="/help/faqs" className={cn("text-black underline font-normal font-['DINPro-Regular_DINPro']", "text-xs mr-3 mt-2", "md:text-sm md:mr-5 md:mt-3")}>{t("common.faqs", "FAQs")}</LocaleLink></div><div className={cn("flex justify-between items-end text-black", "ml-3 mr-3 mt-18", "md:ml-[2.69rem] md:mr-6 md:mt-[5.94rem]")}><div><span className={cn("font-['DINPro-Bold'] font-bold text-black text-center", "text-[2.5rem] md:text-[2rem]   leading-none", "md:text-[3rem] md:leading-12")}>{currentPointsData?.points ?? 0}</span><span className={cn("font-['DINPro-Regular'] font-normal text-black text-left ml-2", " leading-none mb-1", " text-sm md:leading-[0.88rem] md:mb-[0.38rem]")}>{t("points.currentPointsSuffix")}</span></div></div></div></div></div><div className="p-3 mt-3 md:mt-0 md:p-0"><ModuleSectionTitle title={t("account.points.getPointsTitle", "\u7372\u53D6\u7A4D\u5206")} /><div className="h-px bg-[#eee] mt-3 mb-2 md:hidden" /><div className={cn("flex", "gap-2", "md:gap-3")}>{getPointsCards.map(_temp)}</div></div><div className="h-px bg-[#eee] md:hidden mx-3" /><div className="p-3 md:p-0 mt-3 md:mt-12 mb-4"><ModuleSectionTitle title={t("account.points.detailsTitle", "\u7A4D\u5206\u8A73\u60C5")} /><div className="h-px bg-[#eee] my-3 md:hidden" /><div className={cn("block", "md:hidden")}>{pointsHistoryData?.items && pointsHistoryData.items.length > 0 ? <div>{pointsHistoryData.items.map(_temp2)}</div> : <div className={cn("text-center text-[#999]", "py-8")}>{t("account.points.noHistory", "\u6682\u65E0\u79EF\u5206\u8BB0\u5F55")}</div>}</div><table className={cn("hidden w-full text-sm", "md:table")}><thead className={cn("w-full text-[#999] bg-[#f8f8f8] box-border", "text-sm leading-[0.88rem]")}><tr className="w-full"><th className={cn("text-left font-medium w-[20%]", "py-3 pl-6")}>{t("account.points.table.time", "\u6642\u9593")}</th><th className={cn("text-left font-medium w-[40%]", "py-3")}>{t("account.points.table.remark", "\u5099\u8A3B")}</th><th className={cn("text-right font-medium w-[20%]", "py-3 pr-6")}>{t("account.points.table.points", "\u7A4D\u5206")}</th></tr></thead><tbody>{pointsHistoryData?.items && pointsHistoryData.items.length > 0 ? pointsHistoryData.items.map(_temp3) : null}</tbody></table><ModulePagination currentPage={currentPage} totalPages={totalPages} onPageChange={handlePageChange} /></div></div>;
    };
    $[24] = currentPage;
    $[25] = currentPointsData?.points;
    $[26] = getPointsCards;
    $[27] = handlePageChange;
    $[28] = isLoadingCurrentPoints;
    $[29] = isLoadingPointsHistory;
    $[30] = pointsHistoryData;
    $[31] = t;
    $[32] = totalPages;
    $[33] = t11;
  } else {
    t11 = $[33];
  }
  const contentDom = t11;
  let t12;
  if ($[34] !== contentDom || $[35] !== handleRefresh || $[36] !== isMobile) {
    t12 = isMobile ? <PullToRefreshWrapper onRefresh={handleRefresh}>{contentDom()}</PullToRefreshWrapper> : contentDom();
    $[34] = contentDom;
    $[35] = handleRefresh;
    $[36] = isMobile;
    $[37] = t12;
  } else {
    t12 = $[37];
  }
  return t12;
}
function _temp3(item_0) {
  return <tr key={`${item_0.ts}-${item_0.pointsChange}-${item_0.remark}`} className="border-b"><td className={cn("w-[20%]", "pl-6 py-6")}>{formatDate(item_0.ts)}</td><td className={cn("font-medium w-[40%]", "py-6")}>{item_0.remark}</td><td className={cn("font-medium font-['DINPro']  text-right w-[20%]", "pr-6 py-6", item_0.pointsChange > 0 ? "text-destructive" : "text-hint")}>{item_0.pointsChange > 0 ? "+" : ""}{item_0.pointsChange}</td></tr>;
}
function _temp2(item) {
  return <div key={`${item.ts}-${item.pointsChange}-${item.remark}`}><div className={cn("flex justify-between items-start")}><div className="flex-1 "><div className={cn("font-medium", "text-sm leading-none")}>{item.remark}</div><div className={cn("text-[#999]", "text-xs mt-2 leading-none")}>{formatDate(item.ts)}</div></div><div className={cn("font-medium font-['DINPro']  ml-4", "text-sm", item.pointsChange > 0 ? "text-destructive" : "text-hint")}>{item.pointsChange > 0 ? "+" : ""}{item.pointsChange}</div></div><div className="h-px bg-[#eee] my-2.5" /></div>;
}
function _temp(card) {
  return <div key={card.title} className={cn("flex md:flex-col justify-between flex-1 box-border relative md:bg-[#f8f8f8]", "max-w-none  md:p-3", "md:max-w-[21.88rem] md:h-46 md:p-4")}><div><h3 className={cn("font-['DINPro-Medium']", "text-sm md:text-lg leading-5 mb-2 mr-1.5", "md:text-[1.38rem] md:leading-6 md:mb-3")}>{card.title}</h3><p className={cn("font-['DINPro-Regular'] font-normal text-[#d2001e]", "text-xs md:text-sm leading-[0.88rem]", "md:text-base md:leading-4")}>{card.desc}</p></div><div className="flex justify-end"><Button variant="outline" className={cn("   border-black hover:bg-black hover:text-white", "w-20! h-6! md:h-8! md:w-auto! text-xs md:text-sm", "mt-3 text-xs h-8", "md:mt-4 md:h-auto")}>{card.buttonProps.disabled ? card.buttonText : <LocaleLink href={card.link}>{card.buttonText}</LocaleLink>}</Button></div></div>;
}